import React from "react";
import "./footer.css";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="rm-footer">
      <div className="container rm-footer__inner">
        <p>© {year} RecoMeds</p>
      </div>
    </footer>
  );
}
